import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "m10.588 6.237 5.24 5.32a.55.55 0 0 1 .133.205Q16 11.874 16 12a.7.7 0 0 1-.04.238.55.55 0 0 1-.131.205l-5.241 5.335a.73.73 0 0 1-.545.222.76.76 0 0 1-.56-.238.77.77 0 0 1-.233-.554q0-.315.233-.554L14.056 12 9.483 7.346a.75.75 0 0 1-.217-.546q0-.325.233-.563a.74.74 0 0 1 1.089 0"
    }, null, -1)
  ])))
}
export default { render: render }